

export default function BlockAsariSearch() {
  var searchForms = document.querySelectorAll( '.search-form__form' );
  searchForms.forEach( function( searchForm ) {
    searchForm.addEventListener('submit', function(e) {
      var formFields = searchForm.querySelectorAll('select,input');
      formFields.forEach(function(formField){
        if(formField.value.trim() == '') {
          formField.disabled=true;
        }
      });
    });
  } );


}
